module.exports = __webpack_public_path__ + "img/Seafood_App.b626b3b1.jpg";